/**
 * マップレイヤーの描画パラメータのうち、プレイスのラベルに関わる部分を組み替える。
 *
 * 地図画面はプレイスの吹き出しを画面側で描き直す（2行にするため）。
 * タイル側のラベルをそのままにすると二重に表示されるので、
 * **その画面の描画パラメータからプレイスのラベルだけを消す**。
 * 地図画面は自前の描画パラメータを持っている（`UseMapLayerFilter`）ため、
 * プレイスのラベルを描く他の画面には影響しない
 * （2026-08-20 の打ち合わせの決定5「2段のラベルを出すのは地図画面だけ」）。
 */

import _ from 'lodash'
import { MAP_LAYER_REFERENCE_TABLE_TYPE } from '@/constants.js'

/**
 * プレイスのサブレイヤーのパラメータに処理を適用する
 * @param {Array.<Object>} globalParams レイヤー描画パラメータ
 * @param {Array.<Object>} mapLayers マップレイヤーのマスタ
 * @param {String} mvtLayerId MVTレイヤーのID（共通ライブラリの `MapLayerMVTRenderer.layerId`）
 * @param {Function} apply サブレイヤーのパラメータを受け取って書き換える関数
 * @returns {Array.<Object>} 書き換えた描画パラメータ（コピー）
 */
export const mapPlaceSubLayers = (
  { globalParams, mapLayers, mvtLayerId },
  apply
) => {
  const params = _.cloneDeep(globalParams || [])
  for (const param of params) {
    if (param.id !== mvtLayerId) continue
    if (!Array.isArray(param.subLayers)) continue
    for (const subParam of param.subLayers) {
      const layer = (mapLayers || []).find((l) => l.id === +subParam.id)
      if (!layer) continue
      if (layer.reference_table_type != MAP_LAYER_REFERENCE_TABLE_TYPE.PLACE) {
        continue
      }
      apply(subParam)
    }
  }
  return params
}

/**
 * プレイスのタイル側のラベルを消した描画パラメータを作る
 * @param {Array.<Object>} globalParams レイヤー描画パラメータ
 * @param {Array.<Object>} mapLayers マップレイヤーのマスタ
 * @param {String} mvtLayerId MVTレイヤーのID
 * @returns {Array.<Object>} 書き換えた描画パラメータ
 */
export const buildLabelDisabledParams = ({
  globalParams,
  mapLayers,
  mvtLayerId,
}) =>
  mapPlaceSubLayers({ globalParams, mapLayers, mvtLayerId }, (subParam) => {
    // visible は { geometry, label } のオブジェクト。ジオメトリは残しラベルだけ消す
    const visible = subParam.visible
    subParam.visible =
      visible && typeof visible === 'object'
        ? { ...visible, label: false }
        : { geometry: !!visible, label: false }
  })
